import { useEffect } from 'react';

const useTitle = (title: string): void => {
    useEffect(() => {
        document.title = `${title} | Indeed`;
    }, [title]);
};

export default useTitle;
